import { render, staticRenderFns } from "./CohortMembers.vue?vue&type=template&id=138a7647&scoped=true"
import script from "./CohortMembers.vue?vue&type=script&lang=js"
export * from "./CohortMembers.vue?vue&type=script&lang=js"
import style0 from "./CohortMembers.vue?vue&type=style&index=0&id=138a7647&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138a7647",
  null
  
)

export default component.exports